import styled from 'styled-components';
import { NitroGrid } from 'nitro-components';

import { media } from '../../../../utils/style-utils';
import Header from '../../../../components/layouts/Header';

export const NitroGridStyled = styled(NitroGrid)`
  ${media.mobileTablet`
    max-width: 100%;
    flex-basis: 100%;
  `}
`;

export const FBTHeader = styled(Header)`
  ${media.tablet`
    margin-top: ${props => (props.vehicleSwitch ? '75px;' : '15px')};
    margin-bottom: 10px;
  `}

  ${media.mobile`
    margin-top: ${props => (props.vehicleSwitch ? '100px;' : '50px')};
    margin-bottom: 10px;
  `}
`;

FBTHeader.defaultProps = {
  vehicleSwitch: true,
};

export const VDWContainer = styled.div`
  position: absolute;
  right: 140px;
  z-index: 1;

  ${media.mobileTablet`
      position: fixed;
      top: 52px;
      left: 0;
      right: 0;
  `}
`;



// WEBPACK FOOTER //
// ./src/features/fbt/driver/components/nitro-components.styled.js